import { TaskNote } from './task-note';

export interface ExtendedTask extends Task {
  completed?: boolean;
  expanded?: boolean;
  expandable?: boolean;
  subCells?: SubTask[];
  taskText: string;
  taskInputField: string;
}

export enum Statuses {
  Attention = 'Due Date',
  Complete = 'Complete',
  IncompleteSubCells = 'Incomplete Tasks',
  Updated = 'Updated',
  UpdatedApproval = 'Sent For Approval'
}

export enum TaskRecipientSource {
  Manual = 1,
  "Query Builder" = 2
}

export class SubTask {
  actionUri?: string;
  additionalComments?: string;
  createdDatetime!: Date;
  description?: string;
  formData?: string;
  id!: string | null;
  internalComments?: string;
  name!: string;
  pandaDocDocumentId?: number;
  sequenceNumber!: number;
  taskId!: string | null;
  taskInputField?: string;
  taskStatus!: string;
  taskStatusId!: number;
  taskType!: string;
  taskTypeId!: string;
  taskTypeSubTaskId!: string;
  taskText?: string;
  uploadDocumentMaxCount?: number = 0;
}

export class Task {
  accountId!: string;
  accountName!: string;
  actionUri?: string;
  additionalComments?: string;
  assignedAdminAccountId!: string | null;
  dateCreated!: Date;
  description?: string;
  dueDate?: Date | string | null;
  id!: string | null;
  internalComments?: string;
  name!: string;
  programPartnerId?: string;
  programPartnerType!: string;
  programPartnerTypeId?: number;
  programPartnerName?: string;
  institutionName?: string;
  queryId?: string | null;
  workflowId?: string;
  recipientSource: number | undefined;
  subTasks?: SubTask[];
  taskNotes?: TaskNote[];
  taskStatus!: string;
  taskStatusId!: number;
  taskType!: string;
  taskTypeId!: string | null;
  title?: string;
  assignedStudentId!: string | null;
  assignedStudentName?: string;
  modifiedByAccountId?: string;
  modifiedByAccountName?: string;
}

export interface TaskType {
  accountId: string;
  accountName: string;
  actionUri?: string;
  uploadDocumentMaxCount?: number;
  additionalComments?: string;
  assignedAdminAccountId: string | null;
  createdTimestamp: number;
  description?: string;
  dueDate?: Date;
  id: string;
  internalComments?: string;
  name: string;
  programPartnerType: string;
  programPartnerTypeId?: number;
  subTasks: TaskTypeAction[];
  taskType: string;
  taskTypeId: string | null;
  title?: string;
  checkMarkTitle?: string;
  xMarkTitle?: string;
}

export interface TaskAction {
  actionUri?: string;
  createdDatetime: string;
  description: string;
  formData?: string;
  id: string;
  lastDaysBeforeReminderSentDate?: Date;
  lastDueDateReminderSentDate?: Date;
  lastWeeklyReminderSentDate?: Date;
  name: string;
  pandaDocDocumentId?: number;
  previousTaskStatus?: string;
  previousTaskStatusId?: string;
  sequenceNumber: number;
  subTasks?: SubTask[];
  taskId: string;
  taskStatus: string;
  taskStatusId: number;
  taskType: string;
  taskTypeId: string;
  taskTypeSubTaskId: string;
  uploadDocumentMaxCount: number;
}

export interface TaskTypeAction {
  $type: string;
  pandaDocTemplateId: string;
  actionId: string;
  name: string;
  description: string;
  reminderDays: number;
  notifyOnDueDate: boolean;
  sendWeeklyReminders: boolean;
  checkMarkTitle: string;
  xMarkTitle: string;
}

export interface RelatedSubTask {
  taskId: string;
  subTaskId: string;
  programPartnerType?: string;
  accountName?: string;
  assignedStudentName?: string;
  subTaskTitle: string;
  assignedAdminAccountName?: string;
  taskStatus?: string;
  dueDate?: string;
}

export interface PandaDocCreateSessionRequestDto {
  documentId: number;
  recipient?: string;
  lifetime?: number;
}

export interface PandaDocSessionResponseDto {
  id: string;
  url: string;
  expiresAt: Date;
}
